/** Storefront merchandising — stored in site settings under store_copy (Admin → Site). */

export const PRODUCT_CARD_BADGES_DEFAULTS = {
  show_sale_percent: true,
  show_sold_out: true,
  tag_badges: [
    { tag: 'new', label: 'New' },
    { tag: 'bestseller', label: 'Best seller' },
  ],
};

export const HOME_MERCHANDISING_TILES_DEFAULTS = [
  {
    enabled: true,
    icon: '🎁',
    title: 'Gift Finder',
    desc: 'Answer a few questions — we suggest rakhis and lumbas that fit.',
    href: '/gift-finder',
    button_label: 'Start',
  },
  {
    enabled: true,
    icon: '✨',
    title: 'Custom design',
    desc: 'Share your outfit or occasion — we reply with ideas and a quote.',
    href: '/custom-jewelry',
    button_label: 'Enquire',
  },
  {
    enabled: true,
    icon: '🛍️',
    title: 'Shop collections',
    desc: 'Browse handcrafted Rakhi, Lumba, and festive styles.',
    href: '/shop',
    button_label: 'Shop all',
  },
];

export const FOOTER_POPULAR_SEARCHES_DEFAULTS = [
  { label: 'Designer Rakhi', href: '/search?q=rakhi' },
  { label: 'Lumba for Bhabhi', href: '/search?q=lumba' },
  { label: 'Kids Rakhi', href: '/search?q=kids' },
  { label: 'Personalized Rakhi', href: '/search?q=personalized' },
  { label: 'Gift Finder', href: '/gift-finder' },
  { label: 'Track order', href: '/track-order' },
];

export const AUTO_PRODUCT_TAG_SLUGS = ['new', 'bestseller'];

export const AUTO_PRODUCT_TAGS_DEFAULTS = {
  enabled: true,
  new_enabled: true,
  new_days: 45,
  new_since: '2026-07-07',
  bestseller_enabled: true,
  bestseller_days: 30,
  bestseller_limit: 8,
  bestseller_min_views: 3,
  bestseller_min_units: 0,
  views_weight: 1,
  sales_weight: 5,
};

export const STOREFRONT_MERCHANDISING_DEFAULTS = {
  product_card_badges: PRODUCT_CARD_BADGES_DEFAULTS,
  home_trust_strip_enabled: true,
  trust_badge_4: '',
  trust_stat_line: '',
  home_merchandising_enabled: true,
  home_merchandising_tiles: HOME_MERCHANDISING_TILES_DEFAULTS,
  home_testimonials_enabled: false,
  home_testimonials_title: 'What customers say',
  home_testimonials: [],
  footer_popular_searches_enabled: true,
  footer_popular_searches_title: 'Popular searches',
  footer_popular_searches: FOOTER_POPULAR_SEARCHES_DEFAULTS,
  home_product_shelves: [],
  auto_product_tags: AUTO_PRODUCT_TAGS_DEFAULTS,
};
